/**
 * tdesign v0.46.2
 * (c) 2022 tdesign
 * @license MIT
 */

var checkboxGroupProps = {
  disabled: Boolean,
  max: {
    type: Number,
    "default": void 0
  },
  name: {
    type: String,
    "default": ""
  },
  options: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  value: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  defaultValue: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  onChange: Function
};

export { checkboxGroupProps as default };
//# sourceMappingURL=checkbox-group-props.js.map
